import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ExternalImagesOption: LazyOption = createLazyOption(
    {
        key: 'externalImagesOption',
        titleStringKey: 'optionTitle_externalImages',
        searchTermsStringKey: 'optionTitle_externalImages',
        isHidden: () => !isFeatureEnabled('rp-externalImagesProxyOption'),
    },
    lazyFullModule,
    m => m.default
);
export default ExternalImagesOption;
